import always from 'transmute/always';
import { createAction } from 'redux-actions';
import { UPDATE_INSTALL_CODE_PANE_VISIBLE } from '../constants/actionTypes';
export const showInstallCodePane = createAction(UPDATE_INSTALL_CODE_PANE_VISIBLE, always({
  visible: true
}));
export const hideInstallCodePane = createAction(UPDATE_INSTALL_CODE_PANE_VISIBLE, always({
  visible: false
}));